import { signal, effect, batch } from "@preact/signals-core"

const _selectedProvision = signal({})
const _selectedSectionSqid = signal(null)

const selectedProvision = {
  get value() { return _selectedProvision.value },
  set(value) {
    batch(() => {
      _selectedProvision.value = { ...value }
      if(value.sectionSqid) {
        _selectedSectionSqid.value = value.sectionSqid
      }
    })
  },
  effect(fn) {
    return effect(() => fn(_selectedProvision.value))
  }
}

const selectedSectionSqid = {
  get value() { return _selectedSectionSqid.value },
  set(value) {
    batch(() => {
      _selectedProvision.value = {}
      _selectedSectionSqid.value = value
    })
  },
  effect(fn) {
    return effect(() => fn(_selectedSectionSqid.value))
  }
}

export default { selectedProvision, selectedSectionSqid }